// extracted by mini-css-extract-plugin
var _1 = "assets-js-common-components-MegaNav-MegaNavVariant-components-GlobalNav-components-Login-Login-module__loginButton__w1mLl";
export { _1 as "loginButton" }
